export const getters = {
    starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    navbarSearchAndPinList: state => state.navbarSearchAndPinList,
    sidebarWidth: state => state.sidebarWidth,
    bodyOverlay: state => state.bodyOverlay,
    isThemeDark: state => state.theme === 'dark',
    breakpoint: state => state.breakpoint,
    isLoggedIn: state => !!state.authToken,
    authToken: state => state.authToken,
    currentUser: state => state.currentUser,
    idUser: state => state.currentUser.id_pessoa,
    daterange: state => state.daterange,
    relatorioComissoes: state => state.relatorioComissoes,
    dashboard: state => state.dashboard,
    isMobile: state => state.isMobile
};
